var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechnician(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.82894 0.271579C4.06203 -0.166801 5.49181 0.107489 6.47878 1.09446C7.46603 2.08171 7.7402 3.51202 7.30129 4.74535L18.146 15.5902L16.0247 17.7115L5.17887 6.86709C3.94578 7.3055 2.516 7.0312 1.52903 6.04421C0.541782 5.05696 0.267612 3.62665 0.706522 2.39332L2.94325 4.63C3.52903 5.21578 4.47878 5.21578 5.06457 4.63C5.65035 4.04421 5.65035 3.09446 5.06457 2.50868L2.82894 0.271579ZM13.1963 2.15512L16.3783 0.387359L17.7925 1.80157L16.0247 4.98355L14.257 5.3371L12.1356 7.4584L10.7214 6.04421L12.8427 3.92289L13.1963 2.15512ZM6.12523 9.9333L8.2465 12.0546L3.2968 17.0044C2.71101 17.5902 1.76127 17.5902 1.17548 17.0044C0.624152 16.453 0.591722 15.5793 1.07819 14.99L1.17548 14.883L6.12523 9.9333Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnician);
export default __webpack_public_path__ + "static/media/technician.271f7b4b5d3bad5f66da6950380ff693.svg";
export { ForwardRef as ReactComponent };